import React, { useContext } from "react";
import "./contactDetailsCard.css";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { AuthContext } from "../../../../contexts";
import { GROUP_NUMBER } from "../../../../constants/groups";

interface ContactDetailsCardProps {
	open: boolean;
	anchorEl: HTMLElement | null;
	handleClose: () => void;
}

const ContactDetailsCard: React.FC<ContactDetailsCardProps> = ({ open, anchorEl, handleClose }) => {
	const { member } = useContext(AuthContext);
	const isPanhandle = member.group_number === GROUP_NUMBER.BOP_PANHANDLE_FIRST_BANK;
	const isProgressiveLab = member.group_number === GROUP_NUMBER.PROGRESSIVE_LABORATORIES;
	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			onClose={handleClose}
			anchorOrigin={{
				vertical: "top",
				horizontal: "left"
			}}
			transformOrigin={{
				vertical: "top",
				horizontal: "right"
			}}
		>
			<div className="contact-details-main-container">
				<Typography variant="h6">Contact Information</Typography>
				<div className="row">
					<strong>ID cards or claims assistance</strong>
					<span>{isPanhandle || isProgressiveLab ? "Nexcaliber" : "Beazley Limited Indemnity"}</span>
					<span>{isPanhandle || isProgressiveLab ? "(800) 741-0185" : "1-800-508-9238"}</span>
				</div>
				<div className="row">
					<strong>Portal related Queries</strong>
					<span>Becca Boland</span>
					<span>(936) 525-0145</span>
				</div>
			</div>
		</Popover>
	);
};

export default ContactDetailsCard;
